var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-x grid-margin-x grid-margin-y small-up-1 medium-up-3 large-up-4 main"},_vm._l((_vm.orders),function(order,index){return _c('OrdersGridItem',{key:index,staticClass:"cell",attrs:{"order":order}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }